module.exports = node-localstorage;